import { z } from 'zod';

export const OBSERVABLE_KIND_TYPE_OPTIONS = [
  'TINYINT',
  'SMALLINT',
  'INT',
  'BIGINT',
  'FLOAT',
  'DOUBLE',
  'DECIMAL',
  'STRING',
  'BINARY',
  'BOOLEAN',
  'TIMESTAMP',
  'TIMESTAMP_NTZ',
  'DATE',
  'ARRAY',
  'MAP',
  'STRUCT',
  'VARIANT',
] as const;

export const ObservableKindSchema = z.object({
  name: z.string(),
  sqlType: z.enum(['', ...OBSERVABLE_KIND_TYPE_OPTIONS]),
});

export type ObservableKind = z.infer<typeof ObservableKindSchema>;
